import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { simulationRunsPath } from "./constants";
import type {
  CreateSimulationRunErrors,
  PostSimulationRunProps,
  SimulationItemResponse,
  SimulationRun,
} from "./types";

export const postSimulationRun = reactQueryMutationAdapter(
  simulationRunsPath,
  createMutationFetcherFunctionWithShadowError<CreateSimulationRunErrors>()(
    ({ appGroupId, body }: PostSimulationRunProps): Promise<SimulationItemResponse<SimulationRun>> =>
      fetch(`/${appGroupId}/conversational/simulation/runs`, "POST", body, undefined, {
        propagateFetchRequestError: false,
      })
  )
);
